import { useContext } from 'react';

import { AppActions, AppState } from 'src/store/interface';

import { AppStoreContext } from '../providers/appStoreProvider';

export const useAppStore = (): AppState & AppActions => {
  const hook = useContext(AppStoreContext);

  return hook();
};
